import BaseModelAPI from '../BaseModelAPI';

export default class DelegationSettingList extends BaseModelAPI {

	static entity = 'delegationsettinglist'
	static entityName = 'delegationsetting';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
